import { useNavigate } from 'react-router';

// Redux & Action
import { useSelector } from 'react-redux';
import { trackEvent } from "@utility/app/analytics";

// Component
import ImageShow from "views/components/ImageShow";

export default function LogoApp() {
    const history = useNavigate();
    const dataSetting = useSelector(state => state.reduxAppDataSetting.result);

    const handleLogoClick = () => {
        let entryPage = "home";
        const path = window.location.pathname;
        
        // track ว่ามีการกด logo จากหน้าไหน
        if (path.includes("game")) entryPage = "game_page";
        else if (path.includes("lottery")) entryPage = "lottery_page";
        else if (path.includes("promotion")) entryPage = "promotion_page";
        else if (path.includes("profile")) entryPage = "profile_page";
        else if (path.includes("history")) entryPage = "history_page";
        else if (path.includes("affiate")) entryPage = "affiliate_page";
        else if (path.includes("cashback")) entryPage = "cashback_page";
        else if (path.includes("wheel")) entryPage = "wheel_page";
        else if (path.includes("activity")) entryPage = "activity_page";

        trackEvent("logo_click", {
            entry_page: entryPage
        });
        history("/");
    };

    return (
        <div onClick={handleLogoClick}>
            {
                dataSetting !== null ?
                <ImageShow className="imgLogo" src={dataSetting.agent.agent_image} alt="Logo เว็บออนไลน์" />
                :
                null
            }
            
        </div>
    );
}
